import React from 'react';

const SecondaryMenuItems = (props) => {
    const secondaryItems = props.possibleSecondaryMenus[0].map(secMenu => {
        return (
            <p className={`main-menu-item`} key={secMenu}>
                {secMenu}
                </p>
        )
    })
    return (
        <div id="secondary-menu-container" 
        onClick={props.handleSecondaryMenuClick}
        onMouseOver={props.handleMenuHoverIn}
        onMouseLeave={props.handleMenuHoverOut}
        >
            {secondaryItems}
        </div>
    );
};

export default SecondaryMenuItems;